import { filtersDTO, NotZootResponseDTO } from "./dto";
import { NotLivestockServiceImpl } from "./serviceImpl";

export interface NotLivestockService {
    GetAllZootByNot(filters: filtersDTO): Promise<NotZootResponseDTO>
}

export function NewNotLivestockService(): NotLivestockService {
    return new NotLivestockServiceImpl()
}